<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <!-- <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>

      </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <!-- <h4 class="">Our Three Pillars</h4> -->
              <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
              <h2>{{userDetail?.position}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="agent-profile">
  <div class="container">
    <div class="profile-header">
      <div class="profile-img">
        <img [src]="getImageUrl(userDetail?.profilepicFilepath)" width="200" />
      </div>
      <div class="profile-nav-info">
        <h3 class="user-name">{{userDetail?.full_name}}</h3>
        <div class="address">
          <p class="state">{{userDetail?.position}}@</p>
          <span class="country">{{ "Stride Real Estate " + userDetail?.city }}</span>
        </div>
      </div>
      <!-- <div class="profile-option">
        <div class="notification">
          <i class="fa fa-bell"></i>
          <span class="alert-message">1</span>
        </div>
      </div> -->
    </div>
    <div class="main-bd">
      <div class="left-side">
        <div class="profile-side">
          <p class="mobile-no"><i class="fa fa-phone"></i>{{userDetail?.phone_number}}</p>
          <p class="user-mail">
            <i class="fa fa-envelope"></i>{{userDetail?.email}}
          </p>
          <p class="user-mail">
            <i class="fa fa-map-marker-alt"></i>
            {{userDetail?.city + ", " + userDetail?.state}}
          </p>

          <div class="profile-btn">
            <!-- <button class="chatbtn"><i class="fa fa-comment"></i> Contact</button> -->
            <!-- <button class="createbtn"><i class="fa fa-plus"></i> Create</button> -->
          </div>
        </div>
      </div>
      <div class="right-side">
        <div class="nav">
          <ul>
            <li
              class="user-post"
              (click)="opentabPosts()"
              [ngClass]="{ active: posts_open }"
            >
              Bio
            </li>
            <!-- <li
              class="user-reviews"
              (click)="opentabReviews()"
              [ngClass]="{ active: reviews_open }"
            >
              Blog Posts
            </li> -->
          </ul>
        </div>
        <div class="profile-body">
          <div class="profile-posts tab" [ngClass]="{ hidden: !posts_open }">
            <div class="card">
              <h1>My Bio</h1>
              <p>
                {{getBio1(userDetail?.full_name,userDetail?.bio1)}}
              </p>
              <p>
                {{getBio2(userDetail?.bio2)}}
              </p>
              <p>
                {{getBio3(userDetail?.bio3)}}
              </p>
            </div>
            <div class="card">
              <h1>My Blogs</h1>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-mls-listings-agent-page [agentMLS_ID]="userDetail.agentMLS_ID"></app-mls-listings-agent-page>
  <!-- <app-stride-listings></app-stride-listings> -->
</section>
